import * as React from 'react'
import { default as MuiMenuItem, MenuItemProps } from '@mui/material/MenuItem'

export const MenuItem = (props: MenuItemProps) => {
  return <MuiMenuItem {...props} />
}

export default MenuItem
